export default __webpack_public_path__ + "static/media/router-config.ab2fb5e0.png";